import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import certificationCatalog from "../Data/Certdata";
import defaultCert from "../Components/cert.png";

const CertificatesPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const vendor = certificationCatalog.find((v) => v.vendorId === id);

  if (!vendor) return <div className="p-20 text-center font-bold">Vendor not found.</div>;

  return (
    <section className=" min-h-screen pb-20">
      {/* Mobile-Responsive Hero */}
      <div className="bg-white border-b border-slate-200 pt-10 md:pt-24 pb-10 px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <button 
            onClick={() => navigate(-1)} 
            className="flex items-center text-slate-500 font-bold mb-6 hover:text-purple-600 transition-colors"
          >
            <span className="mr-2">←</span> Back
          </button>
          
          <div className="flex flex-col md:flex-row items-center md:items-start text-center md:text-left gap-6 md:gap-10">
            <div className="shrink-0 w-28 h-28 md:w-40 md:h-40 bg-white p-4 rounded-[2rem] shadow-xl shadow-slate-200/50 border border-slate-100 flex items-center justify-center">
              <img 
                src={vendor.vendorLogo || defaultCert} 
                alt="" 
                className="w-full h-full object-contain" 
                onError={(e) => (e.target.src = defaultCert)}
              />
            </div>
            <div className="flex-1">
              <h1 className="text-3xl md:text-5xl font-black text-slate-900 mb-4 leading-tight">
                {vendor.vendorName}
              </h1>
              <p className="text-slate-600 text-base md:text-lg max-w-3xl">
                {vendor.vendorDescription}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 mt-8 md:mt-12 grid grid-cols-1 lg:grid-cols-12 gap-8">
        
        {/* Sidebar: Stats (Appears on top in Mobile) */}
        <div className="lg:col-span-4 order-1 lg:order-1">
          <div className="bg-slate-900 text-white p-6 md:p-8 rounded-[2.5rem] shadow-lg">
            <h2 className="text-xl font-bold mb-6">Quick Overview</h2>
            <div className="space-y-6">
              <div className="flex justify-between items-center">
                <span className="text-slate-400">Total Exams</span>
                <span className="text-2xl font-black text-purple-400">{vendor.certifications.length}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-slate-400">Availability</span>
                <span className="font-bold">Global / Online</span>
              </div>
              <button className="w-full py-4 bg-purple-600 hover:bg-purple-700 rounded-2xl font-bold transition-all mt-4">
                Inquire for Training
              </button>
            </div>
          </div>
        </div>

        {/* Main Content: Exam List */}
        <div className="lg:col-span-8 order-2 lg:order-2">
          <h2 className="text-2xl md:text-3xl font-black text-slate-900 mb-6 px-2">
            Available Certifications
          </h2>
          
          <div className="space-y-4">
            {vendor.certifications.map((exam) => (
              <div 
                key={exam.id} 
                className="bg-white p-5 md:p-7 rounded-3xl border border-slate-100 shadow-sm hover:border-purple-200 transition-all group"
              >
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                  <div className="flex-1">
                    <div className="flex flex-wrap gap-2 mb-3">
                      {exam.code && (
                        <span className="text-[10px] tracking-widest font-bold px-3 py-1 bg-slate-100 text-slate-600 rounded-full uppercase">
                          {exam.code}
                        </span>
                      )}
                      <span className={`text-[10px] tracking-widest font-bold px-3 py-1 rounded-full uppercase ${
                        exam.level === 'Expert' || exam.level === 'Professional' 
                        ? 'bg-orange-100 text-orange-600' 
                        : 'bg-blue-100 text-blue-600'
                      }`}>
                        {exam.level || 'Associate'}
                      </span>
                    </div>
                    <h3 className="text-lg md:text-xl font-bold text-slate-800 group-hover:text-purple-600 transition-colors">
                      {exam.name}
                    </h3>
                    <p className="text-slate-500 text-sm mt-2 leading-relaxed">
                      {exam.details}
                    </p>
                  </div>
                  <div className="sm:text-right">
                    <button className="w-full sm:w-auto px-8 py-3 bg-slate-50 text-slate-900 font-bold rounded-2xl hover:bg-slate-900 hover:text-white transition-all text-sm">
                      Details
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificatesPage;